<template>
  <div class="settings-account">
    <div class="user-account ma-2">
      <user />
    </div>
    <div class="user-dids ma-2">
      <dids />
    </div>
  </div>
</template>

<script>
import User from '@/components/settings/user'
import Dids from '@/components/settings/dids'

export default {
  name: 'settings-account',
  components: {
    User,
    Dids
  }
}
</script>

<style></style>
